import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Eko Cahyanto </span>
            from <span className="purple"> Yogyakarta, Indonesia.</span>
            <br />
            As an experienced programmer, I have the ability to solve problems and develop high-quality applications.
            <br/>
            I have good communication skills and am able to work together with a team in completing projects.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Community gathering
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Never stop doing new things and keep learning!"{" "}
          </p>
          <footer className="blockquote-footer">Eko Cahyanto</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
